import WaitingStateButton from "./WaitingStateButton.jsx";
import RequestStateButton from "./RequestStateButton.jsx";
import ProgressStateButton from "./ProgressStateButton.jsx";

const combinedButtons = {
    WAITING: WaitingStateButton,
    REQUEST_TO_JOIN: RequestStateButton,
    PROGRESS: ProgressStateButton,
}
export default combinedButtons